import React from 'react';
import { useNavigate } from 'react-router-dom';
import { monthLabel } from '../../utils/money';

// تنقّل بالسنة/الشهر؛ يبرز الشهر الحالي ويسِم الأحدث.
export default function MonthSwitcher({ periods, funderId, current }) {
  const navigate = useNavigate();
  if (!periods?.length) return null;

  const idx = periods.findIndex((p) => p.report_month === current);
  const latest = periods[0]?.report_month; // القائمة مرتّبة تنازلياً

  const go = (month) => navigate(`/financial-reports/${funderId}/${month}`);
  const prev = periods[idx + 1]; // أقدم
  const next = periods[idx - 1]; // أحدث

  return (
    <div className="card" style={{ padding: 12, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <button className="btn btn-outline btn-sm" disabled={!next} onClick={() => next && go(next.report_month)} title="الشهر الأحدث">▶ الأحدث</button>

      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', flex: 1 }}>
        {periods.map((p) => (
          <button
            key={p.id}
            className={`btn btn-sm ${p.report_month === current ? 'btn-primary' : 'btn-outline'}`}
            onClick={() => go(p.report_month)}
            title={p.letter_no || ''}
          >
            {monthLabel(p.report_month)}
            {p.report_month === latest && <span style={{ marginInlineStart: 6, fontSize: 10 }}>● الأحدث</span>}
            {p.status === 'draft' && <span style={{ marginInlineStart: 6, fontSize: 10, opacity: 0.7 }}>(مسودّة)</span>}
          </button>
        ))}
      </div>

      <button className="btn btn-outline btn-sm" disabled={!prev} onClick={() => prev && go(prev.report_month)} title="الشهر الأقدم">الأقدم ◀</button>
    </div>
  );
}
